<template>
  <vxe-grid
    ref="vxeGrid"
    auto-resize
    highlight-hover-row
    :data="tableData"
    :columns="tableColumns"
    :loading="loading"
    size="small"
    resizable
    border
    :header-cell-style="
      () => {
        return { backgroundColor: '#bd94c1', color: '#ffffff' }
      }
    "
    :height="235"
  >
    <template v-slot:specInfo="{ row }">
      <span>{{ row.spec }} {{ row.specUnit }}</span>
    </template>
    <template v-slot:defaultImageUrl="{ row }">
      <el-image
        :src="
          row.defaultImageUrl
            ? $osscdn(row.defaultImageUrl)
            : '/image/static/img/nopic.jpg'
        "
        style="width:100px; height:66px"
        :preview-src-list="[
          row.defaultImageUrl
            ? $osscdn(row.defaultImageUrl)
            : '/image/static/img/nopic.jpg',
        ]"
      >
        <div slot="error" class="image-slot">
          <img
            src="/image/static/img/nopic.jpg"
            style="width: 100px; height: 66px"
          />
        </div>
      </el-image>
    </template>
    <template v-slot:opt="{ row }">
      <div>
        <el-tooltip
          class="item"
          effect="dark"
          :content="$l('INDEX.btn_tips_view') || '查看'"
          placement="top"
        >
          <i
            class="el-icon-view tool-btn"
            @click="$emit('openDetailDialog', row)"
          ></i>
        </el-tooltip>
      </div>
    </template>
    <template v-slot:empty="{}">
      <div style="text-align: center">
        <img src="/image/static/img/nodata.png" />
        <p class="no-data mt-2">
          {{ $l('INDEX.table_label_no_data') || '暂无数据！' }}
        </p>
      </div>
    </template>
  </vxe-grid>
</template>
<script>
import tableColumns from './table-columns'
export default {
  props: {
    tableData: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
    showDefaultImage: { type: Boolean, default: false },
  },
  data() {
    return {
      tableColumns: tableColumns(this),
    }
  },
}
</script>
